import moment, { Moment } from 'moment';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { DateFromTo } from 'components/atoms/date-from-to';

type DateValueType = Moment | null;

interface Props {
  startDate: DateValueType;
  dueDate: DateValueType;
  placeholder?: string | ReactNode;
}

export const ContentToRender: FC<Props> = ({ startDate, dueDate }) => {
  const today = moment();
  const tomorrow = moment().clone().add(1, 'day');

  if (!startDate && today.isSame(dueDate, 'day')) {
    return <FormattedMessage id="today" />;
  }
  if (!startDate && tomorrow.isSame(dueDate, 'day')) {
    return <FormattedMessage id="tomorrow" />;
  }

  if (dueDate?.isValid()) {
    return <DateFromTo from={startDate} to={dueDate} />;
  }

  return <FormattedMessage id="choose" />;
};
